<div class="du-mail-popup">
  <div *ngIf="pageType !== 'fullscreen'"
    class="d-flex align-items-center justify-content-between du-mail-popup-header-bg">
    <div class="du-mail-popup-header">New Message</div>
    <mat-icon class="du-mail-popUp-close" (click)="popUpClose()">close</mat-icon>
  </div>

  <div [ngClass]="{'fullscreen-style': pageType === 'fullscreen', 'default-style': pageType !== 'fullscreen'}"
    class="du-mail-popup-container">
    <div class="email-dialog">
      <form>
        <div class="email-fields mb-2">
          <!-- To Field -->
          <div class="form-control d-flex justify-content-between align-items-center mb-2 to-field">
            <div class="d-flex align-items-center flex-wrap gap-2 from-to-items-width">
              <span class="text-muted">To &nbsp;|&nbsp;</span>
              <input matInput type="email" [(ngModel)]="to" name="to" placeholder="Enter recipient email"
                class="to-input">
            </div>
            <div class="right-actions d-flex align-items-center gap-2">
              <i class="bi bi-person-lines-fill text-primary"></i>
              <!-- <a href="#" class="text-decoration-none text-primary small"
                style="font-size:14px;font-weight:500">Contacts</a> -->
              <!-- <span class="text-muted">|</span>
              <a href="#" class="text-decoration-none text-primary small"
                style="font-size:14px;font-weight:500;white-space: nowrap;">Add CC</a> -->
            </div>
          </div>
          <div class="form-control d-flex justify-content-between align-items-center mb-2 to-field">
            <div class="d-flex align-items-center flex-wrap gap-2 from-to-items-width">
              <span class="text-muted">CC &nbsp;|&nbsp;</span>
              <input matInput type="email" name="cc" [(ngModel)]="cc" placeholder="Enter CC email" class="to-input">

            </div>
          </div>

          <!-- Subject Field -->
          <div class="form-control d-flex justify-content-between align-items-center subject-field">
            <div class="d-flex align-items-center gap-2 from-to-items-width">
              <span class="text-muted">Subject</span>
              <span class="text-muted">&nbsp;|&nbsp;</span>
              <input matInput type="text" [(ngModel)]="subject" name="subject" placeholder="Enter subject"
                class="subject-input">
            </div>
            <a class="text-decoration-none text-primary small"
              style="cursor:pointer;font-weight:500;font-size: 14px;white-space: nowrap;"
              (click)="openMailTemplates()">Browse templates</a>
          </div>
        </div>

        <!-- Message Box -->
        <div style="position: relative; height: 100%;">
          <div #messageInput contenteditable="true" class="email-body" (input)="onMessageInput($event)"></div>
          <span class="save-template" (click)="saveTemplate()">Save As Template</span>
        </div>

        <!-- Toolbar -->
        <div class="toolbar">
          <div class="text-options bg-light text-primary">
            <button mat-icon-button (click)="formatText('bold')"><mat-icon>format_bold</mat-icon></button>
            <button mat-icon-button (click)="formatText('italic')"><mat-icon>format_italic</mat-icon></button>
            <button mat-icon-button (click)="formatText('underline')"><mat-icon>format_underlined</mat-icon></button>
            <button mat-icon-button (click)="formatText('justifyLeft')"><mat-icon>format_align_left</mat-icon></button>
            <button mat-icon-button
              (click)="formatText('justifyCenter')"><mat-icon>format_align_center</mat-icon></button>
            <button mat-icon-button
              (click)="formatText('justifyRight')"><mat-icon>format_align_right</mat-icon></button>
            <button mat-icon-button
              (click)="formatText('justifyFull')"><mat-icon>format_align_justify</mat-icon></button>

            <!-- File Upload -->
            <button mat-icon-button (click)="fileInput.click()">
              <mat-icon>attach_file</mat-icon>
            </button>
            <input #fileInput type="file" style="display: none;" (change)="onFileSelected($event)" multiple />

            <!-- Combined Attachment List -->
            <div class="uploaded-files" *ngIf="combinedAttachments.length > 0">
              <div *ngFor="let file of combinedAttachments" class="file-item d-flex align-items-center">
                <mat-icon>insert_drive_file</mat-icon>

                <!-- Template Attachment -->
                <ng-container *ngIf="file.isTemplateFile">
                  <a [href]="file.url" target="_blank">{{ file.name }}</a>
                </ng-container>

                <!-- Uploaded File -->
                <ng-container *ngIf="!file.isTemplateFile">
                  {{ file.name }}
                  <button mat-icon-button (click)="removeUploadedFile(file.index)">
                    <mat-icon>close</mat-icon>
                  </button>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="actions">
            <!-- <button mat-flat-button color="primary">
              <span>Send Secured</span>
              <mat-icon style="margin-left: 8px;">lock</mat-icon>
            </button> -->
            <button mat-flat-button color="primary" (click)="sendEmail()">
              <span>Send Email</span>
              <mat-icon style="margin-left: 8px;">send</mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>